export const detailsAssets = {
  appsActivities: 'apps_activities',
  countryBreakdown: 'country_breakdown',
  pubPerformance: 'publishers_performance',
  topCategories: 'top_categories',
};

export const mpiExplainerAssets = {
  mpiPeriods: 'mpi_periods',
  mpiSummary: 'summary',
  mpiFactors: 'factors',
  mpiInternalFactors: 'internal_factors',
  mpiOverview: 'mpi_overview',
  mpiMomentum: 'mpi_momentum',
  mpiPerformance: 'mpi_performance',
  mpiEntities: 'mpi_entities',
  mpiMetrics: 'mpi_metrics',
  mpiSegments: 'impact_segments',
};

export const performanceAssets = {
  kpiSpotlight: 'kpi_spotlight',
  drivers: 'drivers',
  driversSegments: 'drivers_segments',
  driversEntities: 'drivers_entities',
  driversAdvancedEntities: 'drivers_advanced_entities',
  impactSegments: 'impact_segments',
  crossAppUsage: 'cross_app_usage',
  crossAppUsageApps: 'cross_app_usage_apps',
  keyMetrics: 'key_metrics',
  keyMetricsSeries: 'key_metrics_series',
};

export const defaultFiscalMonth = 'Dec';
export const assetsWithFiscalYearSupport = [
  performanceAssets.drivers,
  performanceAssets.driversSegments,
  performanceAssets.keyMetrics,
  performanceAssets.keyMetricsSeries,
];

export const baseMetrics = {
  downloads: 'Downloads',
  mau: 'Monthly active users',
  iap_revenue: 'IAP revenue',
  sessions: 'Total sessions',
  dau: 'Daily active users',
  tts: 'Total time spent in app',
  engagement: 'Engagement',
  avg_revenue_per_user: 'Avg. revenue per user',
  sessions_per_user: 'Sessions per user',
  total_revenue: 'Total revenue',
  avg_session_len: 'Avg. session length',
  download_revenue: 'Download revenue',
  review_keywords: 'Review keywords',
  daily_app_category_ranks: 'Store rank',
  daily_app_star_ratings: 'Avg. star rating',
  review_sentiments: 'Overall sentiment',
  review_intents: 'Review volume',
  average_time_spent_per_dau: 'Average Time Spent per DAU',
  retention: 'New User Retention',
};
